module.exports = __webpack_public_path__ + "static/img/SSTA_V.384a01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/oceantool/SSTA_V.png
// module id = EYwx
// module chunks = 18